import * as React from 'react';
import { StatusMessage } from '@hvcgroep/design-system';
import { useTranslation } from 'react-i18next';
import { AddressFull } from '../../../../shared/types/opzet';
import MapComponent from '../../components/LeafletMap';
import { containerApi } from '../../store/slices/ContainerApi';
import Button from '../../../../shared/components/Button';
import ContainerList from '../../components/ContainerList';
import { Container } from '../../types';
import SkeletonLoader from '../../components/SkeletonLoader';

interface Props {
  address: AddressFull;
}

const Widget = (props: Props) => {
  const { address } = props;
  const { t } = useTranslation();
  const [excluded, setExcluded] = React.useState<Container['type'][]>([]);

  const { status, data } = containerApi.useGetContainersQuery({
    lat: address.latitude,
    lng: address.longitude,
    municipality_id: address.gemeenteId,
  });
  const [trigger] = containerApi.endpoints.getContainers.useLazyQuerySubscription();

  if ((status === 'pending' || status === null) && !data) {
    return (
      <div className="d-flex align-items-center flex-column">
        <SkeletonLoader type="map" />
        <SkeletonLoader type="list" className="u-margin--top--7" />
      </div>
    );
  }

  if (status === 'rejected' || !data || data.length === 0) {
    return (
      <StatusMessage type="error">
        <p className="mb-4">{t('container_locations.server_errors.get_containers')}</p>
        <Button
          variation="center"
          onClick={() => trigger({
            lat: address.latitude,
            lng: address.longitude,
            municipality_id: address.gemeenteId,
          })}
        >
          {t('container_locations.buttons.retry')}
        </Button>
      </StatusMessage>
    );
  }

  return (
    <div>
      <MapComponent address={address} containers={data} excluded={excluded} />
      <div className="u-indent--large">
        <h3 className="u-margin--top--6">{t('container_locations.container_list.title')}</h3>
        <ContainerList containers={data} setExcluded={setExcluded} excluded={excluded} />
      </div>
    </div>
  );
};

export default Widget;
